import React, { useState } from 'react';
import { storage } from '../components/Firebase.ts';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

interface Props {
isOpen: boolean;
    onClose: () => void;
    onSave: (actividad: { titulo: string; descripcion: string; imagenes: string[] }) => void;
    actividad: { titulo: string; descripcion: string; imagenes: string[] };
    setActividad: React.Dispatch<
    React.SetStateAction<{ titulo: string; descripcion: string; imagenes: string[] }>
    >;
}

const ModalActividadAgre = ({ isOpen, onClose, onSave, actividad, setActividad }: Props) => {
const [imagenes, setImagenes] = useState<File[]>([]);
const [cargando, setCargando] = useState(false);

const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
        setImagenes(Array.from(e.target.files));
    }
};

const handleGuardar = async () => {
    if (!actividad.titulo || !actividad.descripcion || imagenes.length === 0) return;
    setCargando(true);

    try {
        const urls: string[] = await Promise.all(
        imagenes.map(async (img) => {
        const storageRef = ref(storage, `actividades/${uuidv4()}-${img.name}`);
        const snapshot = await uploadBytes(storageRef, img);
        return await getDownloadURL(snapshot.ref);
        })
        );

      // Llamamos al padre con los datos completos
    await onSave({
        titulo: actividad.titulo,
        descripcion: actividad.descripcion,
        imagenes: urls,
    });

      // Limpiar campos
    setActividad({ titulo: '', descripcion: '', imagenes: [] });
    setImagenes([]);
    onClose();
    } catch (err) {
    console.error('Error al subir imágenes:', err);
    }

    setCargando(false);
};

    if (!isOpen) return null;

return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-4 rounded shadow w-full max-w-sm relative">
        <button onClick={onClose} className="absolute top-2 right-3 text-xl">×</button>
        <h2 className="text-lg font-bold text-blue-700 mb-3">Nueva Actividad</h2>

        <input
            type="text"
            placeholder="Título"
            value={actividad.titulo}
            onChange={(e) => setActividad({ ...actividad, titulo: e.target.value })}
            className="w-full border p-1 rounded mb-2 text-sm"
        />

        <textarea
            placeholder="Descripción"
            value={actividad.descripcion}
            onChange={(e) => setActividad({ ...actividad, descripcion: e.target.value })}
            className="w-full border p-1 rounded mb-2 text-sm"
        />

        <input
            placeholder='Selecciona imágenes'
            type="file"
            multiple
            accept="image/*"
            onChange={handleFileChange}
            className="w-full border p-1 rounded mb-3 text-sm"
        />

        <button
            onClick={handleGuardar}
            disabled={cargando}
            className="bg-blue-600 text-white w-full py-1 rounded text-sm hover:bg-blue-700"
        >
            {cargando ? 'Guardando...' : 'Guardar Actividad'}
        </button>
        </div>
    </div>
);
};

export default ModalActividadAgre;
